import React, { useState, useEffect } from 'react';
import produtosUsadosOSService from 'features/estoque/services/produtosUsadosOSService';
import EquipamentosParaTestesTable from './Components/EquipamentosParaTestesTable';
import ClearCacheButton from 'features/estoque/components/ClearCacheButton';

const EquipamentosParaTestes = () => {
  const [dadosCompilados, setDadosCompilados] = useState({});
  const [loading, setLoading] = useState(true);

  // Carregar dados ao montar o componente
  useEffect(() => {
    carregarDados();
  }, []);

  useEffect(() => {
    const handleCompanyChange = () => {
      carregarDados();
    };

    window.addEventListener('company-changed', handleCompanyChange);
    window.addEventListener('company-context-changed', handleCompanyChange);

    return () => {
      window.removeEventListener('company-changed', handleCompanyChange);
      window.removeEventListener('company-context-changed', handleCompanyChange);
    };
  }, []);

  const carregarDados = async () => {
    try {
      setLoading(true);
      const response = await produtosUsadosOSService.buscarEquipamentosParaTestes();
      
      // Verificar se a resposta tem a estrutura SWR
      if (response?.data) {
        // Se tem estrutura SWR (com success, data, cached, etc.)
        if (response.success && response.data) {
          setDadosCompilados(response.data.data);
        } else {
          // Fallback para estrutura antiga
          setDadosCompilados(response.data.data);
        }
      }
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  const equipamentos = dadosCompilados.equipamentos_para_testes?.equipamentos_para_testes || [];

  return (
    <div className="space-y-6">
      {loading && (
        <div className="fixed inset-0 z-[100] flex items-center justify-center backdrop-blur-sm bg-black/20">
          <div
            className="rounded-3xl border border-[color:var(--border)] bg-[color:var(--surface)] px-6 py-5"
            style={{ boxShadow: 'var(--shadow)' }}
          >
            <div className="flex items-center gap-4">
              <div className="loader-elegant" aria-hidden="true"></div>
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[color:var(--text-muted)]">
                  Carregando
                </p>
                <p className="mt-1 text-sm text-[color:var(--text-primary)]">
                  Atualizando dados do período
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-end">
        <ClearCacheButton
          endpoint="equipamentos-para-testes"
          params={{}}
          onReload={carregarDados}
        />
      </div>
      <EquipamentosParaTestesTable 
        data={equipamentos}
        loading={loading}
      />
    </div>
  );
};

export default EquipamentosParaTestes;
